const initialState = {
	gym: null,
	errors: null,
};

export default initialState;
